import React from 'react';
import '../../App.css';
import './Services.css';

export default function Services() {
  return (
    <div>
      <h1>Seja bem vindo(a)</h1>
      <div className='services'>
        <p>A crocheteria de vocês esta aqui,
           toda feliz em poder compartilhar um pouco desse trabalho lindo com vocês.
            Quero também trazer alegria e alto estima através da arte do crochê!
        </p>
      </div>
    </div>
  )
}
